module.exports = __webpack_public_path__ + "static/media/cert_136.b28e9c91.jpg";